import React from 'react'
import Layout from '../../components/layout/Layout'
import imagen from '../../assets/img/unibague.jpg'
const HomeView = () => {
    return (
        <Layout>
            <figure>
                <img src={imagen} alt='Unibague' />    
            </figure>            
        </Layout>
    )
}

export default HomeView
